<section *ngIf="visible" [@fadeIn] class="splash-container">
  <div class="splash-backdrop"></div>

  <svg class="splash-hex" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <pattern id="hex-pattern" width="48" height="56" patternUnits="userSpaceOnUse">
        <path d="M24 0 l24 14 v28 l-24 14 l-24 -14 v-28 z"
              fill="none" stroke="white" stroke-opacity="0.12"/>
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#hex-pattern)" />
  </svg>

  <div class="splash-logo" [@zoomIn]>
    <img [src]="logoSrc" alt="Fraud Deflect logo" />
    <div class="splash-sheen">
      <div class="logo-sheen" (animationend)="onSheenEnd()"></div>
    </div>
  </div>

  <p class="splash-headline">{{ headline }}</p>

  <h1 class="splash-title">
    <span>{{ titleTop }}</span>
    <span *ngIf="titleBottom">{{ titleBottom }}</span>
  </h1>

  <p class="splash-subtitle">{{ subtitle }}</p>

  <div *ngIf="showContinueButton" [@fadeInDelayed]>
<button type="button" class="splash-button" (click)="closeSplash()">{{ buttonText }}</button>
  </div>

  <div class="splash-bottom"></div>
</section>
